import FastMarquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/lib/site";

export default function Marquee() {
  return (
    <section className="border-y border-gold/15 bg-royal-900/50 py-7 overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
      <FastMarquee speed={30} gradient={false} pauseOnHover>
        {MARQUEE_ITEMS.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic text-2xl sm:text-3xl gold-text mx-10 whitespace-nowrap">{item}</span>
            <span className="text-fuchsia text-xl">✦</span>
          </span>
        ))}
      </FastMarquee>
    </section>
  );
}
